import React from "react";

const SpeechBubbleSvg = () => (
  <svg
    viewBox="0 0 115 85"
    css={`
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 100%;
    `}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M31.117 62.262C13.931 62.262 0 48.331 0 31.146 0 13.959 13.931.028 31.117.028c13.869 0 25.618 9.071 29.637 21.604a31.15 31.15 0 0 0-4.977 7.31c-3.689 7.522-4.065 15.808-1.695 23.202-5.689 6.218-13.871 10.118-22.965 10.118zM14.02 20.449c-5.098 2.512-8.605 7.76-8.605 13.828 0 8.505 6.896 15.403 15.404 15.403 4.834 0 9.148-2.227 11.972-5.711.102.002.204.003.307.003 10.764 0 19.492-8.728 19.492-19.493 0-10.769-8.728-19.495-19.492-19.495-9.386 0-17.222 6.63-19.078 15.465z"
      fill="#D73D6F"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.819 49.68c-8.508 0-15.404-6.898-15.404-15.403 0-6.068 3.507-11.316 8.605-13.828a19.53 19.53 0 0 0-.417 4.03c0 10.663 8.563 19.326 19.188 19.49a15.373 15.373 0 0 1-11.972 5.711z"
      fill="#C4254A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M33.098 43.972c-.103 0-.205-.001-.307-.003a15.338 15.338 0 0 0 3.432-9.692c0-8.508-6.897-15.406-15.404-15.406-2.44 0-4.749.568-6.799 1.578 1.856-8.835 9.692-15.465 19.078-15.465 10.764 0 19.492 8.726 19.492 19.495 0 10.765-8.728 19.493-19.492 19.493z"
      fill="#C4254A"
    />
    <path
      d="M32.791 43.969c-10.625-.164-19.188-8.827-19.188-19.49 0-1.381.143-2.73.417-4.03a15.345 15.345 0 0 1 6.799-1.578c8.507 0 15.404 6.898 15.404 15.406 0 3.672-1.286 7.045-3.432 9.692z"
      fill="#B72535"
    />
    <path
      d="M83.691 73.77a30.99 30.99 0 0 1-13.681-3.187c-7.907-3.879-13.435-10.666-15.928-18.439a31.004 31.004 0 0 0 8.153-20.998c0-3.319-.519-6.516-1.481-9.514 5.932-6.488 14.333-10.111 22.983-10.111 4.601 0 9.27 1.024 13.679 3.187 15.432 7.568 21.805 26.211 14.236 41.643a31.007 31.007 0 0 1-8.55 10.644v-.166H92.71a18.654 18.654 0 0 0 6.225-7.202 18.662 18.662 0 0 0 1.151-13.532 15.368 15.368 0 0 0 5.524-11.818c0-8.508-6.895-15.406-15.402-15.406-8.462 0-15.329 6.822-15.405 15.265a18.655 18.655 0 0 0-9.5 8.996c-4.556 9.287-.72 20.507 8.565 25.062a18.653 18.653 0 0 0 11.313 1.663 18.128 18.128 0 0 0 1.076 3.807 31.3 31.3 0 0 1-2.566.106z"
      fill="#D73D6F"
    />
    <path
      d="M54.082 52.144c-2.37-7.394-1.994-15.68 1.695-23.202a31.15 31.15 0 0 1 4.977-7.31 31.088 31.088 0 0 1 1.481 9.514 31.004 31.004 0 0 1-8.153 20.998z"
      fill="#BF243C"
    />
    <path
      d="M103.102 85c-10.044 0-18.171-8.127-18.171-18.171h18.171V85z"
      fill="#D73D6F"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M29.904 55.311c0 10.044-8.128 18.172-18.172 18.172V55.311h18.172z"
      fill="#D73D6F"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M82.103 70.112c-2.769 0-5.581-.616-8.235-1.918-9.285-4.555-13.121-15.775-8.565-25.062a18.655 18.655 0 0 1 9.5-8.996v.141c0 8.505 6.896 15.403 15.405 15.403 3.759 0 7.204-1.348 9.878-3.585a18.662 18.662 0 0 1-1.151 13.532 18.654 18.654 0 0 1-6.225 7.202h-7.779c0 1.032.086 2.044.25 3.028a18.7 18.7 0 0 1-3.078.255z"
      fill="#C4254A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M85.181 69.857a18.412 18.412 0 0 1-.25-3.028h7.779a18.809 18.809 0 0 1-7.529 3.028zM100.086 46.095a18.69 18.69 0 0 0-9.722-11.533 18.666 18.666 0 0 0-8.232-1.917c-2.53 0-5.023.515-7.329 1.491.076-8.443 6.943-15.265 15.405-15.265 8.507 0 15.402 6.898 15.402 15.406 0 4.747-2.147 8.993-5.524 11.818z"
      fill="#C4254A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M90.208 49.68c-8.509 0-15.405-6.898-15.405-15.403v-.141a18.814 18.814 0 0 1 7.329-1.491c2.768 0 5.579.617 8.232 1.917a18.69 18.69 0 0 1 9.722 11.533 15.344 15.344 0 0 1-9.878 3.585z"
      fill="#B72535"
    />
  </svg>
);

export default SpeechBubbleSvg;
